import {Location} from "./machine";
import {isEmpty} from "../../appHelper";

export interface AddPodRequest {
    systemId: string;
    CustomerName: string;
    companyId: number;
    locationId: number;
    podId: string;
}

export const initialAddPodRequest: AddPodRequest = {
    systemId: "",
    CustomerName: "",
    locationId: -1,
    companyId: -1,
    podId: ""
};

export const isAddPodRequestValid = (request: AddPodRequest) => {
    return (
        !isEmpty(request.CustomerName) &&
        !isEmpty(request.systemId) &&
        !isEmpty(request.podId) &&
        request.companyId > -1 &&
        request.locationId > -1
    );
};

export interface Pod {
    id: number;
    systemId: string;
    customerName: string;
    companyName: string;
    location: Location;
    firmware: PodFirmware;
    podId: string;
    phaseCount: string;
    lastMetricTime: number;
}

export interface PodResponse {
    responseCode: string;
    timestamp: number;
    pod: Pod;
}

export interface PodListResponse {
    responseCode: string;
    timestamp: number;
    podList: Pod[];
}

export interface PodFirmware {
    id: number;
    versionName: string;
    status: string;
    requestDate: string;
    updateConformationDate: string;
    lastFirmwareInfoDate: string;
}